import axios from "../axios-auth";

export const qcService = {
  getQCList,
  saveQC,
  getQCDetail,
};

function getQCList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.qcNo) {
    params["qcNo"] = searchParams.qcNo;
  }
  if (searchParams.poNo) {
    params["poNo"] = searchParams.poNo;
  }
  if (searchParams.productId) {
    params["productId"] = searchParams.productId;
  }
  if (typeof searchParams.checkStockIn == 'boolean') {
    params["checkStockIn"] = searchParams.checkStockIn;
  }
  if (typeof searchParams.isNoPurchaseOrder == 'boolean') {
    params["isNoPurchaseOrder"] = searchParams.isNoPurchaseOrder;
  }

  return axios.get("/auth/qcs", { params });
}

function saveQC(qc) {
  if (!qc.id) {
    // new qc
    return axios.post("/auth/qc", qc);
  } else {
    // edit
    return axios.put("/auth/qc", qc);
  }
}

function getQCDetail(id) {
  return axios.get("/auth/qc/" + id);
}
